import "./select.scss"
import React, {useState, useEffect} from 'react';
import {Portals} from "../portals";
import {PopUp} from "../common/co";
import {XScrollView} from "../common/scrollView/sc";

const o = {};
let count = 0;
/**
 * 下拉选择框
 * @param className
 * @param value
 * @param placeholder
 * @param {function} onChange  cb(value)
 * @param {function} onSelect  cb(value)
 * @param {Array} items
 * @param {Component} [children]
 * @param {String} loading
 * @param {function} render (v)=>[key,text]  key - 值 ，text - 显示文字
 * @param popCls
 * @return {*}
 * @constructor
 */
export const Select = ({
                           className = "",
                           placeholder = "",
                           value,
                           children,
                           loading = "",
                           onChange=()=>{},
                           onSelect,
                           items = [],
                           render = ([a, b, c]) => [a, b, c],
                           popCls=''
                       }) => {
    const ls0 = items.map(render);
    const ls = placeholder ? [["", placeholder]].concat(ls0) : ls0;
    let sel = ls.find(c => (c[0] + "") === (value + "")) || [];
    const [act, setAct] = useState(0);
    useEffect(() => {
        if (loading) return;
        const k = ++count;
        o[k] = setAct;
        if (!sel.length && ls.length) {
            onChange(ls[0][0]);
        }
        return () => delete o[k];
    }, [items]);
    return <div className={"x-select " + className + (act ? " on" : "")}>
        <div onClick={(e) => {
            if (loading) return;
            e.stopPropagation();
            e.preventDefault();
            Object.keys(o).forEach(c => o[c](o[c] === setAct ? !act : false));
        }
        }>{children||loading || sel[1]}</div>
        {(loading || ls.length <= 1) ? null : <Portals>
            <PopUp
                cls={"x-select-msk "+popCls}
                close={() => setAct(0)}
                open={() => setAct(1)}
                act={act}>
                <XScrollView trigger={act}>{() => {
                    return <div className={"x-select-opts"}>
                        {ls.map(([k, v, vv], i) => {
                            const isCur = (k + "") === (value + "");
                            return <div
                                onClick={e => {
                                    e.stopPropagation();
                                    setAct(0);
                                    if(onSelect)onSelect(k)
                                    if (!isCur) {
                                        onChange(k)
                                    }
                                }}
                                key={i}
                                className={isCur ? 's' : ''}>
                                {vv || v}
                            </div>
                        })}
                    </div>
                }}</XScrollView>
            </PopUp>
        </Portals>}
    </div>
};
